import { IIconProps } from './icon';

interface IIconOffersPrimary extends IIconProps {
  width?: string;
  height?: string;
  fill?: string;
}

export const IconOffersPrimary = ({
  style = {},
  cy,
  fill = '#793EAD',
  height = '48',
  width = '42',
}: IIconOffersPrimary) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 42"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={cy}
    >
      <path d="M15.7011 6.8252L0.166084 17.5802V41.2502H10.9994V23.2502H19.6661V41.2502H30.4994V17.0627L15.7011 6.8252Z" />
      <path d="M19.6661 0.75V4.1475L23.9994 7.14L27.7477 9.75H30.4994V11.6625L34.8327 14.6775V18.75H39.1661V23.25H34.8327V27.75H39.1661V32.25H34.8327V41.25H47.8327V0.75H19.6661ZM39.1661 14.25H34.8327V9.75H39.1661V14.25Z" />
    </svg>
  );
};
